import { createFileRoute, Navigate } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { AdminPageLayout } from "@/features/admin/components/AdminPageLayout";
import { LearningPathAssignmentsPage } from "@/features/admin/learning-path-assignments/LearningPathAssignmentsPage";
import { usePermissions } from "@/hooks/usePermissions";

export const Route = createFileRoute("/admin/learning-paths/$pathId_/assignments")({
  component: LearningPathAssignmentsRoute,
  remountDeps: ({ params }) => params.pathId,
});

/** Who a learning path is assigned to, and assigning it to more learners. */
function LearningPathAssignmentsRoute() {
  const { pathId } = Route.useParams();
  const { hasPermission } = usePermissions();

  return (
    // ProtectedRoute lets in anyone with the permission OR the role. The page itself needs the
    // permission, which can be taken off any role, SuperAdmin included, so it checks it again.
    <ProtectedRoute requiredPermissions={["LearningPaths.Assign"]} requiredRoles={["SuperAdmin"]}>
      {hasPermission("LearningPaths.Assign") ? (
        <AdminPageLayout mainClassName="bg-secondary_alt">
          <LearningPathAssignmentsPage pathId={pathId} />
        </AdminPageLayout>
      ) : (
        <Navigate to="/admin" />
      )}
    </ProtectedRoute>
  );
}
